module.exports = __webpack_public_path__ + "fonts/Typo_Round_Regular_Demo.f5e7b513.otf";